<template>
  <normal-table
    ref="contractTable"
    class="contract-detector-list"
    :table-col="tableCol"
    :table-data="list"
    :first-table-col="firstTableCol"
    :operate-col="operateCol"
    :operator="operator"
    :show-edit="true"
    :paging="paging"
    @pagination="handleSizeOrPageChange"
  >
  </normal-table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isNumber } from '@/utils/common'

export default {
  name: 'SolidityContractList',
  props: {},
  data() {
    return {
      tableCol: [
        { 
          prop: 'ID', 
          label: '合约ID',
          minWidth: 132 
        },
        { 
          prop: 'Filename', 
          label: '合约文件名',
          minWidth: 160 
        },
        {
          prop: 'Type',
          label: '文件类型',
          formatter: row => {
            return this.transType(row.Type)
          },
          minWidth: 148
        },
        { 
          prop: 'SolcVersion', 
          label: 'Solidity版本',
          minWidth: 134
        },
        {
          prop: 'TaskCount',
          label: '关联任务数',
          formatter: row => {
            return this.formatCount(row.TaskCount)
          },
          minWidth: 107
        },
        {
          prop: 'CreatedAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.CreatedAt)
          },
          minWidth: 195
        },
        {
          prop: 'UpdatedAt',
          label: '更新时间',
          formatter: row => {
            return this.formatTime(row.UpdatedAt)
          },
          minWidth: 195
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          },
          isText: false,
          icon: 'icon-check',
          class: 'operate-check'
        },
        {
          text: '修改',
          click: (row, col, cellValue) => {
            return this.popEditModel(row)
          },
          isText: false,
          icon: 'icon-apply',
          class: 'operate-edit'
        },
        {
          text: '删除',
          isText: false,
          click: (row, col, cellValue) => {
            return this.popConfirmDelete(row)
          },
          icon: 'icon-cancel',
          class: 'operate-delete'
        }
      ],
      operateCol: {
        minWidth: 96
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      },
      paging: {
        total: 0,
        offset: 0,
        limit: 10
      },
      list: []
    }
  },
  mounted() {
    this.getList(this.paging.limit, this.paging.offset)
  },
  methods: {
    ...mapActions([]),
    getList(limit = 20, offset = 0, keywords = '') {
      let params = {
        limit: limit,
        offset: offset
      }
      if (isNumber(keywords) || !isNaN(parseInt(keywords))) {
        params.contract_id = parseInt(keywords)
      } else {
        params.filename = keywords
      }
      let self = this
      this.$apis.contractdetector.getSolidityContractList(params).then(res => {
        if (res && res.data && res.code === 1) {
          self.list = res.data.items
          self.paging.total = res.data.total
          self.paging.offset = res.data.offset
          self.paging.limit = res.data.limit
        } else {
          self.list = []
          self.paging.total = 0
          self.paging.offset = 0
        }
        // console.log(res)
      })
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    transType(type) {
      if (type == 'solidity') {
        return '源码文件'
      } else if (type == 'bytecode') {
        return '字节码文件'
      }
    },
    formatCount(count) {
      if (isNumber(count)) {
        return count
      }
      return this.$constants.EMPTY
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', new Date(time))
    },
    goDetail(row) {
      this.$emit('goDetail', row)
    },
    popEditModel(row) {
      this.$emit('popEditModel', row)
    },
    popConfirmDelete(row) {
      this.$emit('popConfirmDelete', row)
    },
    refresh(keywords) {
      this.getList(this.paging.limit, this.paging.offset, keywords)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('normal-table-wrap', (
  --contract-detector-list-status-create: #45c2ff,
  --contract-detector-list-status-running: #fac20a,
  --contract-detector-list-status-success: #55DA62,
  --contract-detector-list-status-failed: #e95757,
), (
  --contract-detector-list-status-create: #45c2ff,
  --contract-detector-list-status-running: #fac20a,
  --contract-detector-list-status-success: #55DA62,
  --contract-detector-list-status-failed: #e95757,
));
.normal-table-wrap {
  @include adaptation(
    (
      --contract-detector-list-unavailable-height: 111px
    )
  );
  --contract-detector-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--contract-detector-list-unavailable-height)
  );
  height: 100%;
  min-height: var(--contract-detector-list-min-height);

  /deep/ {
    .el-empty {
      height: 100%;
      min-height: var(--contract-detector-list-min-height);
    }

    .normal-table {
      height: 100%;
      min-height: var(--contract-detector-list-min-height);

      .el-table__body tr .el-table__cell .cell .operate-cell .operate-item {

        &.operate-edit {
          color: var(--base-color-success);
        }

        &.operate-delete {
          color: var(--base-color-danger);
        }
      }
    }
  }
}
</style>
